"use client";

import BreadcrumbComp from "@/components/shared/BreadcrumbComp";
import React from "react";
import { AiOutlineClockCircle } from "react-icons/ai";
import NewsItem from "../NewsItem";
import { Button } from "antd";
import Link from "next/link";
import { motion } from "framer-motion";
import { formatDate } from "@/utils/date";
import ReactParser from "html-react-parser";
function NewsDetailIndex({ newDetail, news }) {
  const breadcrumbs = [
    { title: "Trang Chủ", href: "/" },
    { title: "Tin Tức", href: "/tin-tuc" },
    { title: "Chi Tiết Tin Tức", href: "/tin-tuc/chi-tiet-bai-viet" },
  ];

  return (
    <div className="bg-white pb-20">
      <div className="section mx-auto">
        <BreadcrumbComp items={breadcrumbs} />

        {/* Article Header */}
        <div className="mt-8 mb-6">
          <div className="flex items-center gap-2 text-[#06B6D4] text-sm mb-4">
            <AiOutlineClockCircle />
            <span>{formatDate(newDetail?.createdAt)}</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-[#333] mb-8 leading-tight">
            {newDetail?.title || ""}
          </h1>

          <div className="w-full aspect-[21/9] overflow-hidden mb-8">
            <img
              src={newDetail?.thumbnail}
              alt="Detail Banner"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Content */}
        <div className="max-w-[800px] mx-auto text-[#444] leading-relaxed text-justify mb-20">
          {ReactParser(newDetail?.content || "")}
        </div>

        {/* Related News */}
        <motion.div
          initial={{ y: 50, opacity: 0 }} // Trạng thái ban đầu (dưới 50px)
          whileInView={{ y: 0, opacity: 1 }} // Khi cuộn tới thì trượt lên
          viewport={{ once: true }} // Chỉ chạy 1 lần
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="border-t border-gray-200 pt-10">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold text-[#333] capitalize">
                Tin liên quan
              </h2>
              <Link href="/tin-tuc">
                <Button
                  type="primary"
                  className="!text-black !font-semibold !rounded-full !px-6 !py-5"
                >
                  Xem tất cả
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {news
                .filter((item) => item.id !== newDetail?.id)
                .map((item, index) => (
                  <NewsItem key={index} item={item} />
                ))}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default NewsDetailIndex;
